<template>
  <el-button size="mini" type="primary" plain :loading="loading" @click="onSubmit">
    Publish
  </el-button>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    }
  },

  props: {
    recipeId: String,
  },

  methods: {
    async onSubmit() {
      this.loading = true

      try {
        var { data } = await this.$http.put(`/recipes/${ this.recipeId }/status`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.$emit('update')
      this.$message.success(data.message)
    },
  },
}
</script>
